/**
 * @fileoverview React avatar component for event feed messages.
 */

import React from 'react';
import md5 from 'blueimp-md5';
import Tooltip from '../Tooltip';

export interface MessageAvatarProps {
  avatarEmail?: string | null;
  displayName?: string | null;
  initials?: string | null;
  isAuthorClient?: boolean;
  isFirst?: boolean;
}

const MessageAvatar: React.FC<MessageAvatarProps> = ({
  avatarEmail = null,
  displayName = null,
  initials = null,
  isAuthorClient = false,
  isFirst = false,
}) => {
  const avatarClassName = isAuthorClient
    ? 'bl-message_avatar bl-message_avatar-initials'
    : 'bl-message_avatar';

  return (
    <div className="bl-message_avatar-wrapper">
      <Tooltip message={displayName} position={isFirst ? 'bottom' : 'top'}>
        <div className={avatarClassName}>
          {isAuthorClient ? (
            <span>{initials}</span>
          ) : (
            <img
              className="avatar"
              alt={displayName ? `${displayName}'s avatar` : 'User avatar'}
              src={getAvatarUrl(avatarEmail)}
            />
          )}
        </div>
      </Tooltip>
    </div>
  );
};

export default MessageAvatar;

/**
 * Returns the Gravatar URL for the given email, or an empty string if no email
 * is provided. This is exported separately for testing purposes.
 * @param avatarEmail The email address to generate the Gravatar URL for.
 * @returns The Gravatar URL or an empty string.
 */
export function getAvatarUrl(avatarEmail?: string | null): string {
  if (!avatarEmail) {
    return '';
  }

  return `https://secure.gravatar.com/avatar/${md5(avatarEmail)}?d=mm&s=40`;
}
